import { Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import { UserProvider } from "../context/UserContext";

export default function Layout() {
    const [fill, setFill] = useState(true);

    useEffect(() => {
        setTimeout(() => {
            setFill(false);
        }, 700);
    }, [])

    return <>
        {fill && <div style={{ height: "100vh", width: "100%", backgroundColor: "#FFF", position: "fixed", zIndex: "999999", top: 0, left: 0, overflow: "hidden" }}></div>}

        <UserProvider>
            <Outlet />
        </UserProvider>
    </ >
}